<template>
    <b-modal id="samsara-invite-drivers-modal" centered no-close-on-backdrop
        :footer-class="'d-flex justify-flex-end px-3 pt-0 pb-3 m-0'" :body-class="'equipment-edit-modal'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('samsaraInviteDrivers.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body mt-3">
            <b-row>
                <b-col class="px-0">
                    <ol class="fw-600 px-4">
                        <li>{{ $t('samsaraInviteDrivers.step1') }}</li>
                        <li>{{ $t('samsaraInviteDrivers.step2') }}</li>
                        <li>{{ $t('samsaraInviteDrivers.step3') }}</li>
                        <li>{{ $t('samsaraInviteDrivers.step4') }}</li>
                        <li>{{ $t('samsaraInviteDrivers.step5') }}</li>
                    </ol>
                    <div class="text-left mb-3 px-2 position-relative">
                        <label class="state">{{ $t('samsaraInviteDrivers.messageLabel') }}</label>
                        <b-form-textarea rows="11" disabled style="font-size: 14px !important; padding-right: 10%;" class="resize-none f-14"
                            :value="$t('samsaraInviteDrivers.message')"></b-form-textarea>
                        <svg class="copy-samsara-link" width="15" height="15" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg" @click="copyToClipboard($t('samsaraInviteDrivers.message'))">
                            <path
                                d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </div>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer="">
            <b-button class="mx-0 h-40px w-100px m-0" @click="$bvModal.hide('samsara-invite-drivers-modal')"
                variant="secondary">{{ $t('samsaraInviteDrivers.close') }}</b-button>
        </template>
    </b-modal>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "SamsaraTile",
    methods: {
        ...mapActions(['setNotification']),
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.setNotification({
                    msg: this.$t('samsaraInviteDrivers.copied'),
                    type: "success",
                    color: "green",
                });
            });
        }
    },
};
</script>